(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["km-catalog"] && !Shopify.designMode) return;
  try {
    
function initKmCatalog(root) {
  root.querySelectorAll('.km-catalog').forEach(catalog => {
    if(catalog.dataset.ready) return;
    catalog.dataset.ready='true';
    const search=catalog.querySelector('[data-km-search]'), stock=catalog.querySelector('[data-km-stock]');
    if(!search || !stock) return;
    const filter=()=>{
      const term=search.value.trim().toLocaleLowerCase();let total=0;
      catalog.querySelectorAll('.km-product-group').forEach(group=>{
        let count=0;
        group.querySelectorAll('.km-product').forEach(product=>{
          const visible=product.dataset.kmTitle.includes(term) && (stock.value==='all'||product.dataset.kmAvailable===stock.value);
          product.hidden=!visible;if(visible) count++;
        });
        group.hidden=count===0;total+=count;
      });
      catalog.querySelector('[data-km-empty]').hidden=total>0;
    };
    search.addEventListener('input',filter);stock.addEventListener('change',filter);
    catalog.querySelector('[data-km-reset]').addEventListener('click',()=>{search.value='';stock.value='all';filter();});
  });
}
initKmCatalog(document);
document.addEventListener('shopify:section:load',event=>initKmCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
